// src/components/strumenti/MargineRicarico.js — W442. Margine sul prezzo ↔ ricarico sul costo
import React from "react";
import { useCampi, Campo, Modi, Griglia, Risultato, Formula, Azzera, Avviso, euro, fmt } from "./UiStrumento";
import { margineRicarico, prezzoDaRicarico, prezzoDaMargine, margineDaRicarico, ricaricoDaMargine } from "../../utils/calcoliStrumenti";

export default function MargineRicarico() {
  const { v, set, n, azzera, setV } = useCampi({ modo:"prezzo", costo:"", prezzo:"", pct:"" });
  const C = n("costo"), P = n("prezzo"), p = n("pct");
  let titolo = "Margine", valore = "—", righe = [], avviso = null;
  if (v.modo === "prezzo") {
    const r = margineRicarico(C, P);
    if (r) { valore = fmt(r.marginePct, 2) + "%"; righe = [["Ricarico sul costo", fmt(r.ricaricoPct, 2) + "%"], ["Utile", euro(r.utile)]]; }
    if (C > 0 && P > 0 && P < C) avviso = "Il prezzo è sotto il costo: margine e ricarico sono negativi (vendita in perdita).";
  } else if (v.modo === "ricarico") {
    titolo = "Prezzo di vendita"; const pr = prezzoDaRicarico(C, p);
    if (pr !== null && v.pct !== "") { valore = euro(pr); righe = [["Margine sul prezzo", fmt(margineDaRicarico(p), 2) + "%"], ["Utile", euro(pr - C)]]; }
  } else {
    titolo = "Prezzo di vendita"; const pr = prezzoDaMargine(C, p);
    if (pr !== null && v.pct !== "") { valore = euro(pr); righe = [["Ricarico sul costo", fmt(ricaricoDaMargine(p), 2) + "%"], ["Utile", euro(pr - C)]]; }
    if (p >= 100) avviso = "Il margine deve essere sotto il 100% del prezzo.";
  }
  return (
    <div>
      <Modi settore="finanza" valore={v.modo} onChange={(m) => setV(o => ({ ...o, modo:m }))} opzioni={[["prezzo", "Costo e prezzo"], ["ricarico", "Costo + ricarico %"], ["margine", "Costo + margine %"]]}/>
      <Griglia colonne={2}>
        <Campo etichetta="Costo (€)" valore={v.costo} onChange={set("costo")} placeholder="Es. 80"/>
        {v.modo === "prezzo"
          ? <Campo etichetta="Prezzo di vendita (€)" valore={v.prezzo} onChange={set("prezzo")} placeholder="Es. 100"/>
          : <Campo etichetta={v.modo === "ricarico" ? "Ricarico sul costo (%)" : "Margine sul prezzo (%)"} valore={v.pct} onChange={set("pct")} placeholder={v.modo === "ricarico" ? "Es. 25" : "Es. 20"}/>}
      </Griglia>
      {avviso && <Avviso>{avviso}</Avviso>}
      <Risultato settore="finanza" titolo={titolo} valore={valore} righe={righe}/>
      <Formula>Margine % = (prezzo − costo) ÷ <strong>prezzo</strong>. Ricarico % = (prezzo − costo) ÷ <strong>costo</strong>. Un ricarico del 25% dà un margine del 20%: margine = r ÷ (1 + r), ricarico = m ÷ (1 − m). Importi IVA esclusa.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
